var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66663 17H16.6666",
    stroke: "#1B6FED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66663 13H12.6666",
    stroke: "#1B6FED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6666 2.5V3C13.6666 5.82843 13.6666 7.24264 14.5453 8.12132C15.424 9 16.8382 9 19.6666 9H20.1666M20.6666 10.6569V14C20.6666 17.7712 20.6666 19.6569 19.495 20.8284C18.3235 22 16.4378 22 12.6666 22C8.89539 22 7.00978 22 5.8382 20.8284C4.66663 19.6569 4.66663 17.7712 4.66663 14V9.45584C4.66663 6.21082 4.66663 4.58831 5.5527 3.48933C5.73171 3.26731 5.93394 3.06508 6.15596 2.88607C7.25494 2 8.87745 2 12.1224 2C12.828 2 13.1807 2 13.5038 2.11401C13.571 2.13772 13.6368 2.165 13.7011 2.19575C14.0102 2.34355 14.2596 2.593 14.7585 3.09188L19.495 7.82843C20.0731 8.40649 20.3621 8.69552 20.5144 9.06306C20.6666 9.4306 20.6666 9.83935 20.6666 10.6569Z",
    stroke: "#1B6FED",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame2);
export default __webpack_public_path__ + "static/media/Frame2.51ceaa050716440539fb90e39f8048f4.svg";
export { ForwardRef as ReactComponent };